export const AppSettingsActionType = {
	SET_SETTINGS: "SET_SETTINGS",
};
